import TextableModel from '../TextableModel';

export default class Model extends TextableModel {

    constructor(opts = {}) {
        super();
        this.defineAllProperties();

        for (var p in opts) {
            this[p] = opts[p];
        }
    }

    getType() {
        return "EllipseModel";
    }

    toStyle() {

        return {
            ...super.toStyle(),
            borderRadius: `50%`,
            ...super.getExtendStyle(),
        }
    }
}
